import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Panorama36016a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.4A1.2 1.2 0 1 0 8 0a1.2 1.2 0 0 0 0 2.4ZM6.3 3a.8.8 0 0 0-.8.8V7h1v4h1L8 7.87 8.5 11h1V7h1V3.8a.8.8 0 0 0-.8-.8H6.3ZM2 11.378v.005l.001.009a.183.183 0 0 0 .015.036.762.762 0 0 0 .149.19c.181.177.497.386.973.59.927.398 2.278.697 3.862.788V12l3 2-3 2v-1.036l-.002.035c-1.788-.092-3.425-.428-4.648-.953-.61-.26-1.166-.59-1.585-1C.343 12.632 0 12.07 0 11.383c0-1.078.816-1.828 1.601-2.288.837-.492 1.956-.854 3.202-1.08l.355 1.97c-1.109.2-1.98.503-2.545.835-.28.165-.449.315-.538.428a.456.456 0 0 0-.074.13Zm11.386-.558c-.564-.332-1.435-.636-2.544-.836l.355-1.968c1.246.225 2.365.588 3.202 1.079.785.46 1.601 1.21 1.601 2.288 0 1.08-.818 1.83-1.604 2.29-.84.492-1.96.855-3.208 1.08l-.355-1.969c1.112-.2 1.985-.504 2.551-.836.283-.165.45-.316.54-.429a.457.457 0 0 0 .075-.13v-.004l.001-.002v-.005a.455.455 0 0 0-.075-.13c-.09-.113-.257-.263-.539-.428Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Panorama36016a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Panorama36016 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Panorama36016 = createIcon(IconComponent);